//import 'react-app-polyfill/ie11';//for ie
//import 'react-app-polyfill/stable';//for ie
import 'core-js'; 
import cssVars from 'css-vars-ponyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose} from 'redux';
import { createRoot } from 'react-dom/client';
import { withExtraArgument } from 'redux-thunk';

import { HashRouter } from "react-router-dom";

import reducers from './store/reducers';
import deviceRecoveryServices from './libs/deviceRecovery-services';

import * as serviceWorker from './serviceWorker';

import DeviceRecoveryApp from './containers/DeviceRecoveryApp/DeviceRecoveryApp';
import { Chart, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';

import "./index.css";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancer( applyMiddleware(withExtraArgument(deviceRecoveryServices))));

Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement // Needed for Doughnut charts
);

Chart.defaults.font.family = 'HPRegular';


cssVars({
    variables: {
        '--hp-branding-color': '#024AD8',
        '--hp-branding-color-light': '#024ad875'
    },
});

const deviceRecoveryApp = (
    <HashRouter>
        <Provider store={store}>
            <DeviceRecoveryApp />
        </Provider>
    </HashRouter>
);

//ReactDOM.render(deviceRecoveryApp, document.getElementById("DRS-content"));


createRoot(document.getElementById("DRS-content")).render(deviceRecoveryApp);

serviceWorker.unregister();
